import { Entry } from '../Entry'

export function Entry20240208() {
  return (
    <Entry title="Feb 08 2024 - v3.5.14">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/15705/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
